import {DisplayObjectUtils, MovieClip, ReelSymbol} from '@gongxigames/framework/slot';
import {Container} from 'pixi.js';
import {GameReelConstants} from 'src/gameReels/GameReelConstants';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';

export enum FrameIndex {
    normal = 1,
    faded
}

export class GameReelSymbol extends ReelSymbol {
    private static readonly DIMENSION_SHIFT: number = 2;
    protected _dimension: number = GameReelConstants.DEFAULT_DIMENSION;
    public previousStrip = false;

    public setSymbol(symbolID: number): void {
        super.setSymbol(symbolID);
        this.updateDimension();

        if (symbolID !== WolfHaven.Ruby) {
            this.reset();
            this.stopTrailAnimation();
        }
    }

    public set dimension(value: number) {
        this._dimension = value;
        this.updateDimension();
    }

    protected updateDimension(): void {
        (this._symbol.getChildAt(this.symbolType) as MovieClip).gotoAndStop(this.dimension - GameReelSymbol.DIMENSION_SHIFT);
    }

    public get dimension(): number {
        return this._dimension;
    }

    public fadeSymbol(): void {
        ((this._symbol.getChildAt(this.symbolType) as Container).children[0] as MovieClip).gotoAndStop(FrameIndex.faded);
    }

    public reset(): void {
        ((this._symbol.getChildAt(this.symbolType) as Container).children[0] as MovieClip).gotoAndStop(FrameIndex.normal);
        this.stopTrailAnimation();
    }

    public setSymbolFrameIndex(symbolFrameNumber: number, symbolType: number): void {
        const symbolMC = ((this._symbol.getChildAt(symbolType) as Container).children[0] as MovieClip);

        symbolMC && (symbolMC as MovieClip).gotoAndStop(symbolFrameNumber);
    }

    public addBlur(): void {
        const blurredSymbol = DisplayObjectUtils
            .getBlurredSpriteFromCache(`${this._symbolType}_${this.dimension - GameReelSymbol.DIMENSION_SHIFT}`);

        if (blurredSymbol) {
            this.hideSymbol();
            blurredSymbol.anchor.set(0.5);
            this._blurredContainer.addChild(blurredSymbol);
            this._blurredContainer.visible = true;
        }
    }
}
